import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-578ec909"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pager-container" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow-text" }, "Prev", -1))
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow-text" }, "Next", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PagerPageNumber = _resolveComponent("PagerPageNumber")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["arrow prev-arrow", { disabled: !_ctx.prevEnabled }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickPrev && _ctx.onClickPrev(...args))),
      disabled: !_ctx.prevEnabled
    }, [
      _createVNode(_component_font_awesome_icon, {
        class: "arrow-icon",
        icon: ['fas', 'arrow-left']
      }),
      _hoisted_3
    ], 10, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagesToShow, (page) => {
      return (_openBlock(), _createBlock(_component_PagerPageNumber, {
        key: page,
        number: page,
        active: page === _ctx.activePage,
        "on-click": () => _ctx.movePageTo(page)
      }, null, 8, ["number", "active", "on-click"]))
    }), 128)),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["arrow next-arrow", { disabled: !_ctx.nextEnabled }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickNext && _ctx.onClickNext(...args))),
      disabled: !_ctx.nextEnabled
    }, [
      _createVNode(_component_font_awesome_icon, {
        class: "arrow-icon",
        icon: ['fas', 'arrow-right']
      }),
      _hoisted_5
    ], 10, _hoisted_4)
  ]))
}